import { MouseEvent } from 'react';

import { MenuItem } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { useChatContext } from 'features/chat/context/chat';
import { useChatMessagesReadAllMutation } from 'features/chat/hooks/mutation/useChatMessagesReadAll';
import { useToggleChatReadStatusMutation } from 'features/chat/hooks/mutation/useToggleChatReadStatus';

export const ChatHeaderMenuMarkChatAndMessagesReadOption = () => {
  const { isChatMarkedAsUnread } = useChatContext();

  const { mutateAsync: readAllMessages } = useChatMessagesReadAllMutation();

  const { mutateAsync: toggleChatReadStatus } =
    useToggleChatReadStatusMutation();

  const handleChatAndMessagesReadStatus = (evt: MouseEvent) => {
    evt.stopPropagation();

    readAllMessages();
    isChatMarkedAsUnread && toggleChatReadStatus();
  };

  return (
    <MenuItem onClick={handleChatAndMessagesReadStatus}>
      <Icon name={iconNames.chat} /> Mark as read
    </MenuItem>
  );
};
